import React from 'react'
import FormError from '~/common/FormError'
import { Button, Dropdown } from 'react-bootstrap'

type VideoOptionsProps = {
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
  startTime?: string
  setStartTime: (t: string) => void
  hasPrimaryMedia: boolean
  timeInputError: string | undefined
}

const VideoOptions = ({
  isExpanded,
  setIsExpanded,
  startTime,
  setStartTime,
  hasPrimaryMedia,
  timeInputError,
}: VideoOptionsProps) => {
  return (
    <div className={'video-options-container'}>
      <Button className="video-button" variant="outline-secondary" size="lg" onClick={() => setIsExpanded(!isExpanded)}>
        {isExpanded ? 'Remove Video Link' : 'Add Video Link'}
      </Button>

      <p className={'video-link-info'}>Insert a link that opens the video at a selected start time</p>

      {isExpanded && (
        <>
          {!hasPrimaryMedia && <FormError message={'To create a video link, please save as draft first.'} />}
          <div className={'options-inputs'}>
            <div className={'option-column'}>
              <label>Video</label>
              <Dropdown.Toggle disabled={true} variant={'default'}>
                <span>Primary Video</span>
              </Dropdown.Toggle>
            </div>
            <div className={'option-column'}>
              <label>Time (mm:ss)</label>
              <input
                disabled={!hasPrimaryMedia}
                className={'form-control'}
                placeholder={'00:00'}
                value={startTime}
                onChange={e => setStartTime(e.target.value)}
                data-testid={'timestamp-time-input'}
              />
            </div>
          </div>
          {timeInputError && <FormError message={timeInputError} />}
        </>
      )}
    </div>
  )
}

export default VideoOptions
